/* ============================================================
   LOX & CHAIN — Product gallery (desktop carousel arrows)
   Injects custom arrows (with class .lc-pdp-arrow) onto the
   .splide--product element on desktop and wires them to scrollBy
   the .splide__list. All critical styles are applied inline with
   !important so no CSS / Tailwind / Alpine rule can hide them.
   Only runs on desktop (>= 1024px).

   Companion CSS lives in custom.css under the
   "PDP DESKTOP — Horizontal carousel + unified scroll" block.
   ============================================================ */
(function () {
  if (window.__loxcPdpCarouselInit) return;
  window.__loxcPdpCarouselInit = true;

  var PREV_SVG = '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:block;pointer-events:none"><polyline points="15 6 9 12 15 18"/></svg>';
  var NEXT_SVG = '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:block;pointer-events:none"><polyline points="9 6 15 12 9 18"/></svg>';

  function isDesktop() {
    return window.matchMedia('(min-width: 1024px)').matches;
  }

  function setImp(el, prop, val) {
    el.style.setProperty(prop, val, 'important');
  }

  function makeArrow(direction) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lc-pdp-arrow lc-pdp-arrow--' + direction;
    btn.setAttribute('aria-label', direction === 'prev' ? 'Previous image' : 'Next image');
    btn.innerHTML = direction === 'prev' ? PREV_SVG : NEXT_SVG;

    // Flat chevron — no circular container, just the icon with a
    // subtle drop-shadow so it stays readable over any photo.
    setImp(btn, 'position', 'absolute');
    setImp(btn, 'top', '50%');
    setImp(btn, 'transform', 'translateY(-50%)');
    setImp(btn, 'width', '40px');
    setImp(btn, 'height', '40px');
    setImp(btn, 'background', 'transparent');
    setImp(btn, 'border', 'none');
    setImp(btn, 'box-shadow', 'none');
    setImp(btn, 'border-radius', '0');
    setImp(btn, 'display', 'flex');
    setImp(btn, 'align-items', 'center');
    setImp(btn, 'justify-content', 'center');
    setImp(btn, 'cursor', 'pointer');
    setImp(btn, 'z-index', '50');
    setImp(btn, 'padding', '0');
    setImp(btn, 'margin', '0');
    setImp(btn, 'color', '#fff');
    setImp(btn, 'opacity', '1');
    setImp(btn, 'visibility', 'visible');
    setImp(btn, 'pointer-events', 'auto');
    setImp(btn, 'filter', 'drop-shadow(0 1px 3px rgba(0, 0, 0, 0.55))');
    setImp(btn, 'transition', 'transform 160ms ease, opacity 160ms ease');
    if (direction === 'prev') setImp(btn, 'left', '14px');
    else setImp(btn, 'right', '14px');
    return btn;
  }

  function wire(splide) {
    if (!splide || splide.dataset.lcWired === '1') return;

    var list = splide.querySelector('.splide__list');
    if (!list) return;

    splide.dataset.lcWired = '1';

    // Force the splide container to be a regular positioned parent
    // (non-sticky), beating Tailwind's lg:!sticky. We want the image
    // to scroll with the page as one unit, not stay pinned.
    setImp(splide, 'position', 'relative');
    setImp(splide, 'top', 'auto');

    var prev = makeArrow('prev');
    var next = makeArrow('next');
    splide.appendChild(prev);
    splide.appendChild(next);

    function step() {
      var first = list.querySelector('.splide__slide');
      return first ? first.getBoundingClientRect().width : list.clientWidth;
    }

    function updateState() {
      var max = list.scrollWidth - list.clientWidth - 2;
      var hasOverflow = list.scrollWidth > list.clientWidth + 2;
      var atStart = list.scrollLeft <= 2;
      var atEnd = list.scrollLeft >= max;
      // Hide each arrow at its respective extreme. Also hide both
      // entirely if there's only one image (no overflow).
      setImp(prev, 'display', (hasOverflow && !atStart) ? 'flex' : 'none');
      setImp(next, 'display', (hasOverflow && !atEnd) ? 'flex' : 'none');
    }

    prev.addEventListener('click', function () {
      list.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      list.scrollBy({ left: step(), behavior: 'smooth' });
    });

    list.addEventListener('scroll', updateState, { passive: true });
    window.addEventListener('resize', updateState);

    // Recompute once layout / images have settled
    setTimeout(updateState, 100);
    setTimeout(updateState, 800);
    setTimeout(updateState, 2000);
  }

  function scan() {
    if (!isDesktop()) return;
    document.querySelectorAll('.product-media-container .splide--product, .splide.splide--product').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(scan, 400);
    });
  } else {
    setTimeout(scan, 400);
  }

  // Re-run if the product section reloads (Shopify section rendering API)
  document.addEventListener('shopify:section:load', function () {
    setTimeout(scan, 200);
  });

  // Re-run when the window crosses 1024px so it picks up the splide
  // after a desktop resize from mobile.
  var mql = window.matchMedia('(min-width: 1024px)');
  if (mql.addEventListener) mql.addEventListener('change', function () { setTimeout(scan, 200); });
})();